import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

import type { Notification } from 'services/notifications/notifications.types';

import type { DateGroupedNotifications } from './notifications.types';

dayjs.extend(isSameOrAfter);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

export const isHighPriority = (item: Notification): boolean => item.priority > 0;

export const sortNotifications = (items: Notification[]): Notification[] =>
  items.toSorted((a, b) => {
    if (a.priority !== b.priority) return b.priority - a.priority;
    return Date.parse(b.createdAt) - Date.parse(a.createdAt);
  });

export const groupByDate = (items: Notification[]): DateGroupedNotifications => {
  const groups: DateGroupedNotifications = {
    earlier: [],
    highPriority: [],
    last7Days: [],
    today: [],
    yesterday: []
  };

  const sevenDaysAgo = dayjs().subtract(7, 'day').startOf('day');

  for (const item of items) {
    if (isHighPriority(item)) {
      groups.highPriority.push(item);
      continue;
    }

    const date = dayjs(item.createdAt);

    if (date.isToday()) {
      groups.today.push(item);
    } else if (date.isYesterday()) {
      groups.yesterday.push(item);
    } else if (date.isSameOrAfter(sevenDaysAgo, 'day')) {
      groups.last7Days.push(item);
    } else {
      groups.earlier.push(item);
    }
  }

  return groups;
};
